/* eslint-disable react/prop-types */
import { Select } from 'antd';
import { CaregiverFilterSelect } from './controls/CaregiverFilterSelect';
import { ClientFilterSelect } from './controls/ClientFilterSelect';
import { ServiceFilterSelect } from './controls/ServiceFilterSelect';
import { CustomComponentInputs, Filter, FilterColumn } from './filters.types';
import QueryFilters from './QueryFilters';

// Simple test component for custom field
const SimpleCustomSelect: React.FC<CustomComponentInputs> = ({ onChange }) => {
  return (
    <Select
      placeholder="Select an option"
      onChange={onChange}
      style={{ width: '100%' }}
      options={[
        { label: 'Custom Option 1', value: 'custom1' },
        { label: 'Custom Option 2', value: 'custom2' },
        { label: 'Custom Option 3', value: 'custom3' },
      ]}
    />
  );
};

const columns: FilterColumn[] = [
  {
    name: 'dropdown1',
    label: 'Dropdown1',
    type: 'dropdown',
    multipleSelect: true,
    allowClear: true,
    options: [
      { label: 'Option 1', value: 'opt1' },
      { label: 'Option 2', value: 'opt2', active: true },
      { label: 'Option 3', value: 'opt3' },
      { label: 'Option 4', value: 'opt4', active: true },
    ],
  },
  {
    name: 'dropdown2',
    label: 'Dropdown2',
    type: 'dropdown',
    allowSearch: true,
    options: [
      { label: 'Option 1', value: 'opt1' },
      { label: 'Option 2', value: 'opt2' },
      { label: 'Option 3', value: 'opt3' },
      { label: 'Option 4', value: 'opt4' },
    ],
  },
  { name: 'dropdown', label: 'Dropdown', type: 'text' },
  { name: 'name', label: 'Name', type: 'text' },
  { name: 'age', label: 'Age', type: 'number' },
  { name: 'dob', label: 'Date of Birth', type: 'date' },
  {
    name: 'bool',
    label: 'bool',
    type: 'boolean',
    options: [
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' },
    ],
  },
  {
    name: 'user.name.date',
    label: 'User Name',
    type: 'custom',
    component: SimpleCustomSelect,
    operators: ['==', '!='],
  },
  { name: 'user.name.lastname', label: 'date', type: 'date-range' },
  {
    name: 'caregivers',
    label: 'Caregivers',
    type: 'custom',
    component: CaregiverFilterSelect,
    operators: ['==', '!='],
  },
  {
    name: 'clients',
    label: 'Clients',
    type: 'custom',
    component: ClientFilterSelect,
    operators: ['==', '!='],
  },
  {
    name: 'services',
    label: 'Services',
    type: 'custom',
    component: ServiceFilterSelect,
    operators: ['==', '!='],
  },
];

export const FiltersTest = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleApplyFilters = (filters: Filter[]) => {
    // console.log('Applied Filters:', filters);
    // Logic to filter table data based on filters
  };
  return (
    <>
      <div className="w-full max-w-[1400px] p-10 mx-auto">
        <h1 className="text-2xl font-bold mb-6">Advanced Query Filter Builder</h1>
        <QueryFilters joinOperator={'&&'} columns={columns} onApplyFilters={handleApplyFilters} />
      </div>
    </>
  );
};
